export const NEW_NOTIFICATION = 'user/NEW_NOTIFICATION';
export const newNotification = payload => ({
  type: NEW_NOTIFICATION,
  payload,
});
